import { render, staticRenderFns } from "./UnassignedTaskItem.vue?vue&type=template&id=ee028846&scoped=true&"
import script from "./UnassignedTaskItem.vue?vue&type=script&lang=js&"
export * from "./UnassignedTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedTaskItem.vue?vue&type=style&index=0&id=ee028846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee028846",
  null
  
)

export default component.exports